module.exports = __webpack_public_path__ + "img/info.5eaf4101.svg";